import { render, staticRenderFns } from "./Paleta.vue?vue&type=template&id=22150b3e&scoped=true&"
import script from "./Paleta.vue?vue&type=script&lang=js&"
export * from "./Paleta.vue?vue&type=script&lang=js&"
import style0 from "./Paleta.vue?vue&type=style&index=0&id=22150b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22150b3e",
  null
  
)

export default component.exports